module.exports = __webpack_public_path__ + "static/media/gallery26.a1dbcc7a.png";